import NavIcon from "./shared/NavIcon";
import * as IconsFa from "react-icons/fa";
import * as IconsGi from "react-icons/gi";
import * as IconsSl from "react-icons/sl";

function NavMenu({data = defaultData}) {

    const createIcon = (iconName, iconFamily) => {
        let Icon;
        if (iconFamily === 'Fa') {
            Icon = IconsFa[iconName];
        } else if (iconFamily === 'Gi') {
            Icon = IconsGi[iconName];
        } else if (iconFamily === 'Sl') {
            Icon = IconsSl[iconName];
        }
        if (!Icon) {
            console.warn(`El ícono ${iconName} de la familia ${iconFamily} no fue encontrado.`);
            return null;
        }
        return <Icon size='40' color='#FFFFFF' />;
    };
    

  return (
    <div>
        {data.map((item) => (
            <div key={item.id + 'ModalMenu'} style={{textAlign: 'center'}}>
                <NavIcon text={item.navText} buttonFunction={item.function} buttonArguments={item.route}>
                    {createIcon(item.icon, item.iconFamily)}
                </NavIcon>
                <br />
            </div>
        ))}
    </div>
  )
}

const defaultData = [
    {
        id: 0,
        navText: 'Pregunta 1',
        text: 'Enunciado de prueba',
        option1: 'Opción 1',
        option2: 'Opción 2',
        state: false,
        answer: ''
    },
    {
        id: 1,
        navText: 'Pregunta 2',
        text: 'Enunciado de prueba diferente',
        option1: 'Opción A',
        option2: 'Opción B',
        state: false,
        answer: ''
    }
];

export default NavMenu